import { SVGObject } from "../svgobject";

export class SVGSymbol6 extends SVGObject{
    public drawObject():void{
		super.initObject();
        this.svg =`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20000303 Stylable//EN" "http://www.w3.org/TR/2000/03/WD-SVG-20000303/DTD/svg-20000303-stylable.dtd"[]><svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 999 997"><path style="fill:#fff;stroke:#4c4c4c;stroke-width:2" d="M899,997 l24,-4 24,-9 22,-16 16,-22 9,-25 5,-23 0,-799 -5,-26 -9,-25 -16,-19 -22,-16 -24,-11 -24,-2 -800,0 -26,2 -24,11 -20,16 -16,19 -11,25 -2,26 0,799 2,23 11,25 16,22 20,16 24,9 26,4 800,0z" /><path style="fill:#f00" d="M366,366 l-267,0 0,265 267,0 0,267 266,0 0,-267 267,0 0,-265 -267,0 0,-267 -266,0 0,267z" /></svg>`
		super.fillGradients();
        super.drawObject();
    }
}